/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    getErrorDetailsFn,
    getInputFieldProps,
    removeSpecialCharAndNumFn,
    safeToString,
    sliceText,
} from "../../../../utils/common";
import useAPIHandler from "../../../../hook/use-api-handler";
import { holidayValidationSchema } from "./holiday-validation";
import { HOLIDAY_INITIAL_STATE } from "./holiday-management-constant";
import { logger, safeString } from "../../../../utils/logger";


const useHolidayService = ({ openSnackbar }) => {

    const [holiday, setHoliday] = useState(HOLIDAY_INITIAL_STATE);
    const [holidayListinfo, setholidayListinfo] = useState([]);
    const [errors, setErrors] = useState({});

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 2,
        total: 0,
        totalPages: 1,
    });




    const { fetchData } = useAPIHandler();

    async function holidayLists(page = 1, pageSize = 10) {
        try {
            const URL = `/admin/holiday?page=${page}&pageSize=${pageSize}`;
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                setholidayListinfo(result.data.holidays);
                setPagination({
                    page: result?.data?.pagination?.page || 1,
                    pageSize: result?.data?.pagination?.pageSize || 2,
                    total: result?.data?.pagination?.total || 0,
                    totalPages: result?.data?.pagination?.totalPages || 1,
                });
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "holidayName") {
            value = sliceText((safeString(value)), 150)
        }

        setHoliday((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = holidayValidationSchema.extract(name);
        const { error } = fieldSchema.validate(value);
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }

    }

    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = holidayValidationSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }



    const handleSubmit = async () => {
        try {
            const { holidayName, holidayDate, holidayType } = holiday;

            // Validate inputs
            const { error } = holidayValidationSchema.validate(
                { holidayName, holidayDate, holidayType },
                { abortEarly: false }
            );

            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                    acc[err.path.join(".")] = err.message;
                    return acc;
                }, {})
                : {};

            setErrors(validationErrors);

            if (Object.keys(validationErrors).length > 0) {
                return false;
            }

            // API call to create holiday
            const response = await fetchData({
                url: "/admin/holiday",
                method: "POST",
                data: { holidayName, holidayDate, holidayType },
            });

            if (response.status === "success") {
                setHoliday(HOLIDAY_INITIAL_STATE);
                openSnackbar({
                    message: "Holiday Created Successfully",
                    color: "success",
                });
                holidayLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred while creating the holiday");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };

    const handleUpdate = async (id) => {
        try {
            const { holidayName, holidayDate, holidayType } = holiday;

            // Validate inputs
            const { error } = holidayValidationSchema.validate(
                { holidayName, holidayDate, holidayType },
                { abortEarly: false }
            );

            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                    acc[err.path.join(".")] = err.message;
                    return acc;
                }, {})
                : {};

            setErrors(validationErrors);

            if (Object.keys(validationErrors).length > 0) {
                return false;
            }

            // API call to update holiday
            const response = await fetchData({
                url: `/admin/holiday/${id}`,
                method: "PUT",
                data: { holidayName, holidayDate, holidayType },
            });

            if (response.status === "success") {
                setHoliday(HOLIDAY_INITIAL_STATE);
                openSnackbar({
                    message: "Holiday Updated Successfully",
                    color: "success",
                });
                holidayLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred while updating the holiday");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };

    // Helper function to handle API errors consistently
    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = error.errors.reduce((acc, curr) => {
                const { field, message } = curr;
                acc[field] = message;
                return acc;
            }, {});
            setErrors(errorsAll);
            openSnackbar({
                message: Object.keys(errorsAll).length > 0 ? "Validation Error!" : "Something went wrong!",
                color: "danger",
            });
        } else {
            const backendMessage = typeof error.message === "string" ? error.message : "An unexpected error occurred.";
            openSnackbar({ message: backendMessage, color: "danger" });
        }
        logger.log(error);
    };


    //   function hanldeAddAnotherFn() {
    //     setaddAnother((prev) => !prev);
    //   }

    useEffect(() => {
        holidayLists()
    }, []);


    const today = new Date();

    // Set today's date and end of the next year
    const currentYear = today.getFullYear();
    const nextYear = currentYear + 1;

    // Minimum date is today
    const minDateObj = new Date(today);
    const minFormattedDate = minDateObj.toISOString().split('T')[0];

    // Maximum date is 31st December of the next year
    const maxDateObj = new Date(nextYear, 11, 31); // December 31st of next year
    const maxFormattedDate = maxDateObj.toISOString().split('T')[0];


    return {
        holidayListinfo,
        holiday,
        errors,
        setErrors,
        handleChange,
        handleBlurFn,
        maxFormattedDate,
        minFormattedDate,
        setHoliday,
        handleSubmit,
        handleUpdate,
        holidayLists,
        pagination
    };
};

export default useHolidayService;